import { createContext, useContext, useReducer } from 'react';
import { SubmissionPublicationSearchState, SubmissionPublicationSearchReducer, ACTION_TYPES } from './submission-publication-search-reducer';
import moment from 'moment';
import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submissin-publication-paged-request';

const SubmissionPublicationSearchContext = createContext<SubmissionPublicationSearchState | undefined>(undefined);
const SubmissionPublicationSearchDispatchContext = createContext({} as any);

const SubmissionPublicationSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: SubmissionPublicationSearchState = {
        users: [],
        status: [],
        datesParameters: {
            starDatePicker: moment().add(-30, 'd'),
            endDatePicker: moment()
        },
        parameters: {
            startDate: moment().add(-30, 'd').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            id: undefined,
            statusId: [1],
            types: [1, 2],
            userSenderId: undefined,
            page: 0,
            pageSize: 100
        } as ISubmissionPublicationPagedRequest,
        submissionPublicationId: undefined
    };

    const [state, dispatch] = useReducer(SubmissionPublicationSearchReducer, initialState);

    return (
        <SubmissionPublicationSearchContext.Provider value={state}>
            <SubmissionPublicationSearchDispatchContext.Provider value={dispatch}>
                {children}
            </SubmissionPublicationSearchDispatchContext.Provider>
        </SubmissionPublicationSearchContext.Provider>
    );
}

const useSubmissionPublicationSearchState = () => {
    const context = useContext(SubmissionPublicationSearchContext);
    if (context === undefined) {
        throw new Error('useSubmissionPublicationSearchState must be used within a SubmissionPublicationSearchProvider');
    }
    return context;
}

const useSubmissionPublicationSearchDispatch = () => {
    const context = useContext(SubmissionPublicationSearchDispatchContext);
    if (context === undefined) {
        throw new Error('useSubmissionPublicationSearchDispatch must be used within a SubmissionPublicationSearchProvider');
    }
    return context;
}

export { SubmissionPublicationSearchProvider, useSubmissionPublicationSearchDispatch, useSubmissionPublicationSearchState, ACTION_TYPES };
